import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

function Login() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSuccess = (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      
      if (!decoded.email || !decoded.email.endsWith('@ivalue.co.in')) {
        setErrorMessage('Access denied. Only requested email addresses are allowed.');
        setOpenSnackbar(true);
        return;
      }
      
      localStorage.setItem('user', JSON.stringify({
        name: decoded.name,
        email: decoded.email,
        picture: decoded.picture,
      }));
      window.location.href = '/dashboard';
    } catch (e) {
      console.error('Failed to decode user info', e);
    }
  };
  return (
    <Box sx={{
      minHeight: '100vh',
      width: '100vw',
      background: 'linear-gradient(135deg, #0a2240 0%, #1e3a5f 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decorative background shapes */}
      <Box sx={{
        position: 'absolute',
        top: -120,
        left: -120,
        width: 320,
        height: 320,
        background: 'radial-gradient(circle, #00b4a0 0%, transparent 70%)',
        opacity: 0.18,
        zIndex: 0,
        borderRadius: '50%',
      }} />
      <Box sx={{
        position: 'absolute',
        bottom: -100,
        right: -100,
        width: 260,
        height: 260,
        background: 'radial-gradient(circle, #1e90ff 0%, transparent 70%)',
        opacity: 0.15,
        zIndex: 0,
        borderRadius: '50%',
      }} />
      <Paper elevation={6} sx={{
        zIndex: 1,
        p: { xs: 3, sm: 5 },
        borderRadius: 4,
        minWidth: 340,
        maxWidth: 380,
        width: '100%',
        textAlign: 'center',
        background: 'rgba(10,34,64,0.97)',
        color: 'white',
        boxShadow: '0 8px 32px rgba(30, 144, 255, 0.12)',
      }}>
        {/* Logo or Brand */}
        <Box sx={{ mb: 2 }}>
          <Box sx={{
            width: 'auto',
            height: 56,
            mx: 'auto',
            mb: 1,
            borderRadius: 2,
            background: 'linear-gradient(135deg, #00b4a0 0%, #1e90ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 32,
            fontWeight: 900,
            color: 'white',
            letterSpacing: -2,
            boxShadow: '0 2px 12px rgba(30, 144, 255, 0.12)',
          }}>
            {/* Placeholder for logo, can use an SVG or image */}
            <img src="https://cdn.ivaluetv.com/public/ivalue transparent white.png" alt="iValue SIEM" style={{ width: 'auto', height: 32 }} />
          </Box>
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, letterSpacing: -1, background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
          Welcome to Confluent COE
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: '#e0f7fa', fontWeight: 400 }}>
          Sign in to access your real-time security dashboard.
        </Typography>
        <Box
          sx={{
            width: '100%',
            minWidth: 240,
            mx: 'auto',
            mb: 2,
            display: 'flex',
            justifyContent: 'center', // <-- Add this
            alignItems: 'center',
          }}
          className="google-login-btn-wrap"
        >
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => {
              console.log('Login Failed');
            }}
            width="100%"
            theme="filled_blue"
            shape="pill"
          />
        </Box>
        <Typography variant="caption" sx={{ mt: 3, display: 'block', color: '#b0bec5' }}>
          Powered by Google OAuth
        </Typography>
      </Paper>

      {/* Modern Snackbar Alert */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setOpenSnackbar(false)} 
          severity="error"
          variant="filled"
          sx={{ 
            minWidth: 400,
            backgroundColor: '#d32f2f',
            color: 'white',
            boxShadow: '0 8px 32px rgba(211, 47, 47, 0.4)',
            borderRadius: 2,
            '& .MuiAlert-icon': {
              fontSize: 28,
              color: 'white'
            },
            '& .MuiAlert-message': {
              color: 'white'
            },
            '& .MuiAlert-action': {
              color: 'white'
            }
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5, color: 'white' }}>
            Access Denied
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.95)' }}>
            {errorMessage}
          </Typography>
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Login;